const mobilePhoneCodes = ['04', '05'];
const SUCCESS_CODE = '00';

module.exports = {
    mobilePhoneCodes,
    SUCCESS_CODE
};
